<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<h1>Acknowledgment</h1>
<p>I want to thank The ONE SOURCE DEVINE ENERGY that led me onto this beautiful journey. I want to thank my lovely wife for her love and support. I want to thank my publishing team for their hard work and patience. Most importantly, I want to thank ALL the readers who enjoy this material.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?25113ad7